import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Row, Col, Button} from 'reactstrap';
import {connect} from 'react-redux';
import { isNull } from 'lodash';
import images from './images/images'

const PaymentProcessBackComponent = (props) => {
  const paymentData = props.data.selectedForUpdate.customersPaymentData;

  function getLastFourDigits(number) {
    const numStr = String(number);
    return numStr.substr(-4);
  }

  return (
<div className='newPaymentBox'>
  <div className='background-container payment-process-back-container'>
    <div className='proccess-payment-header'>
    <Image src={images.newcreditcard} alt="Credit Card" className="card-icon-image" style={{ width: '24px', height: '24px' }} />
    <h4 className="header" style={{fontSize: '16px',fontWeight: '400',marginBottom: '-3px'}}>אמצעי לעדכון</h4>
    </div>
    <div className="divider"></div>

    {props.data.selectedForUpdate.customersPaymentData.map((paymentData, paymentIndex) => {
      const checkedCustomers = paymentData.customersList?.filter(customer => customer.checked === true) || [];
      const lastFourDigits = paymentData.paymentMethodNumber;

      if (checkedCustomers.length === 0) {
        return null;
      }

      const accountsText = checkedCustomers.map(c => c.number).join(' | ');
      return (
        <div key={paymentIndex} className="payment-method-section">
          <div className="payment-summary-row">
            <span className="payment-summary-number">
              {lastFourDigits && lastFourDigits.trim() !== ''
                ? `**** ${getLastFourDigits(lastFourDigits)}`
                : '****'}
            </span>
            <span className="payment-summary-accounts">:חשבונות שיעודכנו<br/>{accountsText}</span>
          </div>
        </div>
      );
    })}
  </div>
</div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.updatePayment,
  };
};

        {/* <Button
          color='link'
          className='purple-text back-link pt-1 pb-0 payment-process-back-link pr-0'
          onClick={() => props.buttonFunction()}>
          לשינוי הבחירה
        </Button>
        {!props.data.isBusinessBlock && (
          <p className='pink-text' style={{fontWeight: 'bold', marginBottom: 'unset', marginTop: '5px'}}>
            שימו לב, אפשר לעדכן כרטיס ששייך לבעל החשבון בלבד
          </p>
        )} */}

export default connect(mapStateToProps, null)(PaymentProcessBackComponent);
